import React from 'react'
import BackgroundImage from 'gatsby-background-image'

import { Typography } from '@material-ui/core'

import useStyles from './styles'

const Hero = ({ img, pageTitle, pageSubtitle, secondary, darker }) => {
  const { hero, mainPageText, secondaryPageText } = useStyles({
    secondary,
    darker,
  })
  return (
    <BackgroundImage className={hero} fluid={img}>
      <Typography component="h1" className={mainPageText}>
        {pageTitle}
      </Typography>
      <Typography component="span" className={secondaryPageText}>
        {pageSubtitle}
      </Typography>
    </BackgroundImage>
  )
}

export default Hero
